import { axiosInstance } from "./axiosInstance";

// 💡 1. 일반 고객용: 사용 중인 카테고리 목록 조회 (isMain=true 이면 주요 카테고리만)
export const getCategories = async (isMain?: boolean) => {
    const params = isMain ? { isMain: 'Y' } : {};
    const response = await axiosInstance.get("/api/categories", { params });
    return response.data;
};

// 💡 2. 관리자용: 카테고리 전체 목록 조회 및 설정
export const getAdminCategories = async () => {
    const response = await axiosInstance.get("/api/admin/categories");
    return response.data;
};

// 💡 3. 관리자용: 주요 카테고리(메인 노출) 토글 변경
export const toggleMainCategory = async (categoryId: number) => {
    const response = await axiosInstance.patch(`/api/admin/categories/${categoryId}/toggle-main`);
    return response.data;
};

// 💡 4. 관리자용 전체 노출(사용) 여부 토글 변경
export const toggleVisibleCategory = async (categoryId: number) => {
    const response = await axiosInstance.patch(`/api/admin/categories/${categoryId}/toggle-visible`);
    return response.data;
};

// 💡 신규: 카테고리 등록
export const createAdminCategory = async (data: any) => {
    const response = await axiosInstance.post("/api/admin/categories", data);
    return response.data;
};

// 💡 신규: 카테고리 수정
export const updateAdminCategory = async (categoryId: number, data: any) => {
    const response = await axiosInstance.put(`/api/admin/categories/${categoryId}`, data);
    return response.data;
};

// 💡 신규: 카테고리 순서 일괄 변경
export const updateCategorySort = async (sortData: { categoryId: number; sortOrder: number }[]) => {
    const response = await axiosInstance.patch("/api/admin/categories/sort", sortData);
    return response.data;
};